<script setup>
import StatusDot from "@/shared/ui/status-dot/StatusDot.vue";
import { Spinner } from "@/shared/ui/spinner";

defineProps({
  document: {
    type: Object,
    required: true,
    default: () => ({
      number: "",
      status: "",
      statusLabel: "",
      date: "",
      created_at: "",
      title: "",
      notary: "",
    }),
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["open"]);
</script>

<template>
  <div class="flex flex-col gap-3">
    <div v-if="loading" class="flex justify-center items-center py-8">
      <Spinner size="sm" />
    </div>
    <div v-else class="document-card" role="button" @click="emit('open')">
      <div class="header">
        <div class="number">№ {{ document.number }}</div>
        <div class="status">
          <StatusDot :code="document.status" />
          <span class="status-text">{{ document.statusLabel }}</span>
        </div>
      </div>
      <div v-if="document.registration_date" class="date">
        {{ document.registration_date }}
      </div>
      <div class="meta">
        <div class="row">
          <span class="icon"></span>
          <span class="text">{{ document.title || $t("Не указано") }}</span>
        </div>
        <div class="row">
          <span class="icon user"></span>

          <span class="text">
            <span class="label">{{ $t("Нотариус:") }}</span>
            {{ document.notary || $t("Не указано") }}
          </span>
        </div>
        <div class="row">
          <span class="text">
            <span class="label">{{ $t("Дата создания:") }}</span>
            {{ document.created_at || $t("Не указано") }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped lang="scss">
.document-card {
  @apply w-full p-5 bg-card rounded-[20px] outline outline-1 outline-offset-[-1px];
  @apply outline-border flex flex-col gap-4 cursor-pointer;

  .header {
    @apply w-full flex items-center justify-between;
  }

  .number {
    @apply text-base font-semibold text-foreground leading-6;
  }

  .status {
    @apply flex items-center gap-1.5;
  }

  .status-text {
    @apply text-sm font-semibold text-foreground leading-5;
  }

  .dot {
    @apply w-2 h-2 rounded-full;
  }

  .dot-green {
    @apply bg-green-600;
  }

  .dot-yellow {
    @apply bg-yellow-500;
  }

  .dot-gray {
    @apply bg-gray-400;
  }

  .date {
    @apply flex items-center gap-2 text-sm font-normal text-muted-foreground leading-5;
  }

  .meta {
    @apply flex flex-col gap-x-2;
  }

  .row {
    @apply flex items-start gap-y-2;

    svg {
      @apply w-5 h-5 text-muted-foreground;
    }
  }

  .text {
    @apply text-xs font-normal text-foreground leading-4;
  }

  .label {
    @apply font-semibold;
  }

  &.is-loading {
    @apply pointer-events-none opacity-70;
    position: relative;
  }
}
</style>
